module.exports = __webpack_public_path__ + "static/media/client_linking.b205c1c7.svg";